import { persistExpiryDate, readExpiryDate } from '@app/services/localStorage.service';
import { getUsers } from '@app/api/user.api';
import { createAction, PrepareAction,Slice, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface ExpiryDateState {
  expiryDate: Date | null;
}

const initialState: ExpiryDateState = {
  expiryDate: readExpiryDate(),
};

export const setExpiryDate = createAction<PrepareAction<string>>('expiryDate/setExpiryDate', (newExpiryDate) => {
    persistExpiryDate(newExpiryDate);

  return {
    payload: newExpiryDate,
  };
});

export const expiryDateSlice = createSlice({
  name: 'ExpiryDate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setExpiryDate, (state, action) => {
      state.expiryDate = action.payload ?  new Date(action.payload) : null;
    });
  },
});

export default expiryDateSlice.reducer;
